// extracted by mini-css-extract-plugin
export default {"innerWrapper":"rw-z","tooltipWrapper":"sw-z","icon":"tw-z","tooltip":"uw-z","content":"vw-z"};